import { z } from 'zod';
import { ArgoConnectionKindEnum } from '../db';

export const mqttBrokerConnectionConfigSchema = z.object({
    kind: z.literal(ArgoConnectionKindEnum.MqttBroker),
    details: z.object({
        url: z.string(),
        username: z.string(),
        password: z.string(),
    }),
});
export type MqttBrokerConnectionConfig = z.infer<typeof mqttBrokerConnectionConfigSchema>;
